import {airBlueLight} from '@modifi/colors'
import {Row} from '@modifi/ui'
import styled from 'styled-components'

export const StyledRow = styled(Row)`
  margin: 0;
  cursor: pointer;
  padding: 16px 8px;

  &:hover {
    background-color: ${airBlueLight};
  }
`

export const ActionsIconWrapper = styled.div<{isOpen: boolean}>`
  padding: 4px 1px;
  ${({isOpen}): string => (isOpen ? ` border-radius: 6px; background-color: ${airBlueLight}` : '')}
`

export const ActionsWrapper = styled.span<{isLast?: boolean}>`
  div[data-ident='dropdown-content-wrapper'] {
    padding: 0px;
    transform: translateY(-${({isLast}): number => (isLast ? 80 : 60)}%);
    right: 24px;
  }
`
